import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { observer } from 'mobx-react';
import { TreeItemModal } from '@/common/components/TreeItemModal/TreeItemModal';
import DriveItemDetailsFooter from '@/drive/components/DriveItemDetailsModal/DriveItemDetailsFooter';
import { useDriveItemModalForm } from '@/drive/components/DriveItemModal/useDriveItemModalForm';
import DriveItemModalForm from '@/drive/components/DriveItemModalForm/DriveItemModalForm';
import DriveItemPreview from '@/drive/components/DriveItemPreview/DriveItemPreview';
import { MediaSize } from '@/media/constants/sizeCodes';
import styles from './DriveItemDetailsModal.module.less';
function DriveItemDetailsModal(props) {
    const { form, preview, title, onClose, onSubmit, isUrlFieldShown, usePortal } = props;
    const { values, errors, handleSubmit, setFieldValue } = useDriveItemModalForm(async (formValues) => {
        onClose?.();
        onSubmit?.(formValues);
    }, form, isUrlFieldShown);
    return (_jsx(TreeItemModal, { usePortal: usePortal, isShowed: !!form, onClose: onClose, title: title, treeShown: false, previewShown: false, formContent: (_jsxs(Fragment, { children: [preview && _jsx(DriveItemPreview, { preview: preview, mediaSize: MediaSize.Small }), _jsx(DriveItemModalForm, { className: styles.form, values: values, errors: errors, setFieldValue: setFieldValue, isUrlFieldShown: isUrlFieldShown, onSubmit: handleSubmit, onReset: onClose })] })), footerContent: _jsx(DriveItemDetailsFooter, {}) }));
}
export default observer(DriveItemDetailsModal);
